var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6616 1.16406C8.22603 1.16406 1.32422 8.06587 1.32422 16.5014C1.32422 24.937 8.22603 31.8388 16.6616 31.8388C25.0971 31.8388 31.9989 24.937 31.9989 16.5014C31.9989 8.06587 25.193 1.16406 16.6616 1.16406Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4438 13.9133H9.18457V23.7867H12.4438V13.9133Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145 12.5713C9.66417 12.5713 8.99316 11.8044 8.99316 10.8458C8.99316 9.88723 9.76003 9.12036 10.8145 9.12036C11.9648 9.12036 12.6358 9.88723 12.6358 10.8458C12.7316 11.8044 11.9648 12.5713 10.8145 12.5713Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3306 23.7866H21.0714V18.5144C21.0714 17.1724 20.5921 16.3097 19.4418 16.3097C18.5791 16.3097 18.0039 16.8848 17.7164 17.5558C17.6205 17.7475 17.6205 18.0351 17.6205 18.3227V23.8825H14.3613C14.3613 23.8825 14.3613 14.9676 14.3613 14.009H17.6205V15.4469C18.0998 14.7759 18.8667 13.8173 20.5921 13.8173C22.7969 13.8173 24.3306 15.2552 24.3306 18.2268V23.7866Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLn);
export default __webpack_public_path__ + "static/media/footer_ln.5e829b7ddfe1068496ddbaa6d6114d00.svg";
export { ForwardRef as ReactComponent };